export interface Memorizable {
	value: string | number// dq always returns string!
	label?: string
	azetext?: string
	html?: string
	color?: string // font color
	background?: string // background color
	valuecolor?: string
	valuebackground?: string
	dotcolor?: string // dot at the end
	textcss?: string // css applied on wrapper
	tooltip?: string
	hidden?: string | boolean // return anything or null in dq
	disabled?: string | boolean // return anything or null in dq
	// sortnr?: number // excluded!
}

export const MemorizableAttributes = [
	'value',
	'label',
	'azetext',
	'html',
	'color',
	'background',
	'valuecolor',
	'valuebackground',
	'dotcolor',
	'textcss',
	'tooltip',
	'hidden',
	'disabled',
	// 'sortnr' // excluded!
] as const

export function isMemorizable(x: any): x is Memorizable {
	if (!x) return false
	return Boolean((x.value || x.value === 0) && !x.disabled && !x.hidden)
}